import ReactDOM from 'react-dom/client'

//
import App from './App'
import * as serviceWorker from './serviceWorker'
import reportWebVitals from './reportWebVitals'
import { AppWraper } from './services/AppWrapper/AppWraper'
import { msalInitPromise } from './config/msalConfig'

// ----------------------------------------------------------------------

const root = ReactDOM.createRoot(document.getElementById('root'))

/**
 * Wait for MSAL to fully initialize (hydrate cached accounts from localStorage)
 * before rendering the app. This prevents the race condition where
 * useIsAuthenticated() returns false during startup and causes a blank page.
 */
msalInitPromise.then(() => {
  root.render(
    <AppWraper>
      <App />
    </AppWraper>
  )
})

// If you want to enable client cache, register instead.
serviceWorker.unregister()

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
